/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsHardDriveOutline: {
  name: 'hard-drive-outline';
  data: string;
} = {
  name: 'hard-drive-outline',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.83 4.106A2 2 0 0 1 8.617 3h6.764a2 2 0 0 1 1.789 1.106l3.723 7.447c.14.28.137.593.018.858A2 2 0 0 1 21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 .088-.59.998.998 0 0 1 .018-.857l3.723-7.447ZM15.381 5l3 6H5.618l3-6h6.764ZM5 13h14v6H5v-6Zm7 2a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-4Zm-4 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
